/**
 * RetirementGraph component module.
 * @module shared/components/RetirementGraph
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import Pie from '../../../../shared/components/graphs/Pie';
import {_openModal} from '../../../../shared/reducers/modals';
import {connect} from 'react-redux';
import useSWR from 'swr';
import history from '../../../../history';
import useQueryObject from '../../../../shared/utils/useQueryObject';
import {LoadingSpinner} from '../../../../shared';
import Row from '../../../../shared/components/Row';
import {withTheme} from 'styled-components/macro';
import {buildQueryContext} from '../../../../shared/utils/utils';

const RetirementGraph = ({containerID, theme}) => {
  const [context] = useQueryObject('context');
  const {data} = useSWR(containerID && `/containers/${containerID}/accounts/types`);
  const formattedData = React.useMemo(() => data && data.length
    ? data.reduce((types, type) => {
      types[type.isRetirement ? 0 : 1].y += type.count;
      return types;
    }, [
      {name: 'Retirement', color: theme.dark ? '#99FA66' : '#79AF30', y: 0},
      {name: 'Non-Retirement', color: theme.dark ? '#FFCC03' : '#CF790B', y: 0},
    ])
    : [{name: 'No Accounts', color: '#797B83', y: 1}], [data]);

  if (!formattedData) {
    return <LoadingSpinner/>;
  }

  return <Row height={'100px'}
              alignSubRow={'stretch'}
              alignItems={'stretch'}
              layout={{grow: 1}}>
    <Pie data={formattedData}
         sliceAction={slice => history.push(`/analyze/containers/${containerID}/accounts?${buildQueryContext(
           context,
           {isRetirement: slice.name === 'Retirement' ? 1 : 0}
         )}`)}/>
  </Row>;
};

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default withTheme(connect(null, mapDispatchToProps)(RetirementGraph));

RetirementGraph.propTypes = {
  openModal: PropTypes.func,
  containerID: PropTypes.number.isRequired,
  theme: PropTypes.object,
};
